import React from 'react';
import { Pencil } from 'lucide-react';
import { getPublicCategoryDisplayLimit } from './categoryVisibility';

function BasicSidebarCategoriesCard({ category, listing, canEdit = false, onEdit }) {
  const assigned = Array.isArray(listing?.listingCategories)
    ? listing.listingCategories.map((entry) => entry?.tenantCategory).filter(Boolean)
    : [];
  const primary = assigned.find((item) => !item.parentId) || assigned[0] || null;
  const secondary = assigned.filter((item) => item.id !== primary?.id && item.parentId === primary?.id);
  const derivedCategories = [primary, ...secondary]
    .map((item) => item?.name)
    .filter((name) => typeof name === 'string' && name.trim())
    .map((name) => name.trim());
  const categoryList = Array.from(new Set([primary?.name || category, ...derivedCategories].filter(Boolean)))
    .slice(0, getPublicCategoryDisplayLimit(listing?.tier));

  return (
    <section
      id="SidebarCategoriesCard"
      className="rounded-lg border p-4"
      style={{ borderColor: 'var(--ui-input-border)', backgroundColor: 'var(--card)' }}
    >
      <div className="flex items-start justify-between gap-3">
        <h3 className="text-sm font-semibold text-black">Categories</h3>
        {canEdit ? (
          <button
            type="button"
            aria-label="Edit Categories"
            title="Edit Categories"
            onClick={onEdit}
            className="inline-flex h-8 w-8 items-center justify-center rounded-md border text-[var(--primary)] transition-colors hover:bg-black/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--primary)]/30"
            style={{ borderColor: 'var(--ui-input-border)' }}
          >
            <Pencil size={15} aria-hidden="true" />
          </button>
        ) : null}
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        {categoryList.length > 0 ? categoryList.map((item) => (
          <span
            key={item}
            className="rounded-md border px-2 py-1 text-xs font-medium text-black/80"
            style={{ borderColor: 'var(--ui-input-border)', backgroundColor: 'var(--surface)' }}
          >
            {item}
          </span>
        )) : (
          <span className="text-xs text-black/60">No categories available</span>
        )}
      </div>
    </section>
  );
}

export default BasicSidebarCategoriesCard;
